/*
 * Manifest Llibres, 2026-10-09
 * Corregeix un fals avís a la cistella ("Només podeu afegir X d'aquest article").
 * El tema comparava el recompte d'articles amb un valor guardat en carregar la pàgina,
 * que no s'actualitzava en afegir llibres des del botó de compra.
 * Els errors reals d'estoc continuen arribant de Shopify i es mostren a #cart-errors.
 */
(function () {
  function patch() {
    var CartItems = customElements.get('cart-items');
    if (!CartItems || CartItems.prototype.__manifestFix) return;
    CartItems.prototype.__manifestFix = true;
    CartItems.prototype.updateLiveRegions = function (line, itemCount) {
      this.currentItemCount = itemCount;
      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);
      var live = document.getElementById('cart-live-region-text');
      if (live) {
        live.setAttribute('aria-hidden', false);
        setTimeout(function () { live.setAttribute('aria-hidden', true); }, 1000);
      }
    };
  }
  if (window.customElements) {
    if (customElements.get('cart-items')) patch();
    else customElements.whenDefined('cart-items').then(patch);
  }
})();
